import { FC } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IRideDto, IStyledAttributes } from "@ryde/shared";

import { RideFeedbacksCount } from "../../common";

const FeedbacksCountCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "feedback-count-cell",
})``;

export const FeedbackCountCell: FC<Partial<IRideDto>> = rideDto => {
  return (
    <FeedbacksCountCellStyled className="allow-overflow">
      <RideFeedbacksCount {...rideDto} shouldHideIcon shouldTruncateText />
    </FeedbacksCountCellStyled>
  );
};
